import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccessToken } from '@models/account/access-token.model';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { MigForm } from '@models/forms/mig-form.model';
import { ModelService } from '@services/common/model.service';
import { OnInit } from '@angular/core';
import { StepComponent } from '../../abstract/step.component';
import { User } from '@models/account/user.model';
import { alertFire } from '@functions/alerts';

@Component({
  selector: 'app-resident-name',
  templateUrl: './resident-name.component.html',
  styleUrls: ['../../../mig-form.component.scss'],
})
export class ResidentNameComponent extends StepComponent implements OnInit {
  formData: FormGroup = this.builder.group({
    firstName: [null, [Validators.required]],
    lastName: [null, [Validators.required]],
  });
  submit = false;
  created = false;

  constructor(
    builder: FormBuilder,
    @Inject('MigFormService')
    service: ModelService<MigForm>,
    api: CommonVerbsApiService
  ) {
    super(builder, service, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.service.model) {
      this.formData.patchValue({
        firstName: this.service.model.user?.firstName,
        lastName: this.service.model.user?.lastName,
      });
      if (this.service.model.user?.id) {
        this.created = true;
      }
    }
  }

  get form() {
    return this.formData.controls;
  }

  ngSubmit() {
    if (!this.created) {
      this.submit = true;
      if (this.formData.invalid) {
        return;
      } else {
        alertFire('This action cannot be undone!').then(result => {
          if (result.value) {
            let params = this.formData.getRawValue();
            params = { ...params, communityId: this.model?.community };
            const subscribe = this.api
              .post<{
                token: { accessToken: AccessToken; plainTextToken: string };
                user: User;
              }>('users/bd-register', params)
              .subscribe(response => {
                this.created = true;
                if (response && response.user && this.model) {
                  this.model.user = response.user;
                  this.service.set(this.model);
                  this.nextStep.emit();
                }
              });
            this.unsubscribe.push(subscribe);
          }
        });
      }
    } else {
      this.nextStep.emit();
    }
  }
}
